export class ResponseError extends Error {
    public constructor(public readonly response: Response) {
        super();
    }
}
